const state = () => ({
  isLoading: false,
  errorMessage: "",
  selectedMenu: "",
  menu: {
    dashboard: false,
    orders: true,
    accounts: true,
  },
  drawer: true,
  isMobile: false,
  snack: false,
  snackText: "",
  snackErr: false,
  snackErrText: "",
  pageCount: 0,
  editInvoiceOneModalView: false,
  latestPriceModalView: false,
  editShortageModalView: false,
  editCustomerModalView: false,
  editCustomerAddressModalView: false,
  addEmployeeModalView: false,
  editEmployeeModalView: false,
  deleteEmployeeModalView: false,
  templateModalView: false,
  editTemplateModalView: false,
  searchProductModalView: false,
  searchAccountModalView: false,
});

const getters = {
  getIsLoading: (state) => () => state.isLoading,
};

const mutations = {
  changeIsLoading: (store, payload) => {
    store.isLoading = payload.isLoading;
  },
  error: (store, payload) => {
    store.errorMessage = payload.errorMessage;
  },
  changeSelectedMenu: (store, payload) => {
    store.selectedMenu = payload.selectedMenu;
  },
  changeEditInvoiceOneModalView: (store) => {
    store.editInvoiceOneModalView = !store.editInvoiceOneModalView;
  },
  changeLatestPriceModalView: (store) => {
    store.latestPriceModalView = !store.latestPriceModalView;
  },
  changeEditShortageModalView: (store) => {
    store.editShortageModalView = !store.editShortageModalView;
  },
  changeEditCustomerModalView: (store) => {
    store.editCustomerModalView = !store.editCustomerModalView;
  },
  changeEditCustomerAddressModalView: (store) => {
    store.editCustomerAddressModalView = !store.editCustomerAddressModalView;
  },
  changeEditEmployeeModalView: (store) => {
    store.editEmployeeModalView = !store.editEmployeeModalView;
  },
  changeDeleteEmployeeModalView: (store) => {
    store.deleteEmployeeModalView = !store.deleteEmployeeModalView;
  },
  changeAddEmployeeModalView: (store) => {
    store.addEmployeeModalView = !store.addEmployeeModalView;
  },
  changeTemplateModalView: (store) => {
    store.templateModalView = !store.templateModalView;
  },
  changeEditTemplateModalView: (store) => {
    store.editTemplateModalView = !store.editTemplateModalView;
  },
  changeSearchProductModalView: (store) => {
    store.searchProductModalView = !store.searchProductModalView;
  },
  changeSearchAccountModalView: (store) => {
    store.searchAccountModalView = !store.searchAccountModalView;
  },
  snackOn: (store, payload) => {
    store.snack = true;
    store.snackText = payload.text;
  },
  snackErrOn: (store, payload) => {
    store.snackErr = true;
    store.snackErrText = payload.text;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
